import './index.scss';

import PromiseModal from 'components/modals/promise_modal';
import AbuseReportModal from 'components/modals/abuse_report_modal';
import './index.scss';

export default class ActivityReply {
  constructor(reply) {
    if (reply.activityReplyInstance) return;

    this.$reply = $(reply);
    this.replyId = reply.dataset.commentId;
    this.activityId = reply.dataset.commentActivityId;
    this.parentCommentId = reply.dataset.parentCommentId;
    this.$dates = $('.js-activity-reply-datetime', this.$reply);
    // This is disabled for now
    // this.$updateButton = $('.js-reply-update', this.$reply);
    this.$deleteButton = $('.js-activity-reply-delete', this.$reply);
    this.$reportButton = $('.js-activity-reply-report', this.$reply);
    this.bindAll();

    reply.activityReplyInstance = this;
  }

  /**
   *
   * ActivityReply API
   * publish | delete | report | update (disabled)
   *
   */

  static publish(message, activityId, parentCommentId) {
    if (!message || !parentCommentId) return;

    return Thor.ActivityReplies
      .create_and_render({
        activity_id: activityId,
        activity_comment_id: parentCommentId
      }, {
        data: {
          reply: {
            message
          },
          component_name: 'timeline/activity_reply'
        }
      });
  }

  static delete(activityId, parentCommentId, replyId) {
    return new Promise((resolve, reject) => {
      PromiseModal.call({
        question: 'Tem certeza que deseja deletar esse comentário?',
        modalType: 'danger'
      }, res => {
        if (res) {
          Thor.ActivityReplies
            .delete({
              activity_id: activityId,
              activity_comment_id: parentCommentId,
              id: replyId
            })
            .then(response => resolve(response))
            .catch((err) => reject(err));
        } else {
          reject('Usuário cancelou a ação');
        }
      });
    });
  }

  static report(activityId, activityCommentId, replyId, reason) {
    return Thor.ActivityReplies.report_abuse(
      {
        id: replyId,
        activity_comment_id: activityCommentId,
        activity_id: activityId
      }, {
        data: {
          text: reason
        }
      });
  }

  // This is disabled for now
  // static update(activityId, parentCommentId, replyId, message) {
  //   return new Promise((resolve, reject) => {
  //     Thor.ActivityReplies
  //       .update({
  //         activity_id: activityId,
  //         activity_comment_id: parentCommentId,
  //         id: replyId
  //       }, {
  //         data: {
  //           reply: {
  //             message
  //           },
  //           component_name: 'timeline/activity_reply'
  //         }
  //       })
  //       .then(response => resolve(response))
  //       .catch((err) => reject(err));
  //   });
  // }

  /**
   *
   * ActivityReply User Actions
   * Delete | Report | Update (disabled)
   *
   */

  bindReplyDeleteButton() {
    if (!this.$deleteButton) return;

    this.$deleteButton.on('click', e => {
      e.preventDefault();

      this.constructor.delete(this.activityId, this.parentCommentId, this.replyId)
        .then(() => {
          this.$reply.slideUp(300, () => this.$reply.remove());
        })
        .catch(err => console.log(err));
    });
  }

  bindReplyReportButton() {
    if (!this.$reportButton) return;

    this.$reportButton.on('click', e => {
      e.preventDefault();
      AbuseReportModal.openForTimelineReply({
        activityId: this.activityId,
        activityCommentId: this.parentCommentId,
        replyId: this.replyId
      });
    });
  }

  // This is disabled for now
  // TODO : refactor this to trigger a modal that receives a message to update the reply
  // bindReplyUpdateButton() {
  //   if(!this.$updateButton) return;

  //   this.$updateButton.on('click', e => {
  //     e.preventDefault();
  //     const message = 'testing update';

  //     this.constructor.update(this.activityId, this.parentCommentId, this.replyId, message)
  //       .then(response => console.log(response))
  //       .catch(err => console.log(err));
  //   });
  // }

  /**
   *
   * ActivityReply Extras
   * Moment humanized dates
   *
   */

  bindReplyDates() {
    this.$dates.toArray().forEach(date => {
      date.innerHTML = moment(date.getAttribute('datetime'), moment.ISO_8601).locale('pt-br').fromNow();
    });
  }

  bindAll() {
    this.bindReplyDeleteButton();
    // This is disabled for now
    // this.bindReplyUpdateButton();
    this.bindReplyReportButton();
    this.bindReplyDates();
  }
}
